import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { MobileNav } from '../components/MobileNav';
export function LifeDecodeAccess() {
  const navigate = useNavigate();
  const [isReady, setIsReady] = useState(false);
  // Simulate decode preparation (in production, this would check actual status)
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsReady(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);
  const handleReadDecode = () => {
    navigate('/decode/life/output');
  };
  const handleLater = () => {
    navigate('/archive');
  };
  return <>
      <Helmet data-id="element-2344">
        <title data-id="element-2345">Life Decode Available | Lazy Monk Labs</title>
      </Helmet>

      <div className="min-h-screen bg-[#0A0A0A] text-[#F5F5F5]" data-id="element-2346">
        <MobileNav data-id="element-2347" />

        <main className="pt-20 sm:pt-24 pb-24 sm:pb-32" data-id="element-2348">
          <div className="max-w-xl mx-auto px-6 sm:px-8" data-id="element-2349">
            {/* Centered content with generous vertical spacing */}
            <div className="min-h-[60vh] flex flex-col justify-center" data-id="element-2350">
              {/* PRIMARY LINE */}
              <h1 className="text-2xl sm:text-3xl text-[#F5F5F5] mb-8 sm:mb-10" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-2351">
                Life Decode available
              </h1>

              {/* SUPPORTING COPY */}
              <div className="space-y-5 text-base text-gray-400 leading-[1.7] mb-12 sm:mb-16" data-id="element-2352">
                <p data-id="element-2353">
                  This decode looks at the same pattern you just saw, but across
                  the full arc of your life.
                </p>
                <p data-id="element-2354">There's no need to rush. Most people read this in parts.</p>
              </div>

              {/* PRIMARY CTA */}
              <div className="mb-6" data-id="element-2355">
                {isReady ? <button onClick={handleReadDecode} className="px-8 py-4 bg-[#F5F5F5] text-[#0A0A0A] text-sm font-medium hover:bg-gray-200 transition-colors" data-id="element-2356">
                    Read Life Decode
                  </button> : <div className="space-y-4" data-id="element-2357">
                    <p className="text-base text-gray-400" data-id="element-2358">
                      Preparing your Life Decode…
                    </p>
                    <p className="text-sm text-gray-500" data-id="element-2359">
                      This usually takes a moment. You don't need to stay on
                      this screen.
                    </p>
                  </div>}
              </div>

              {/* SECONDARY OPTION */}
              <div className="mb-16" data-id="element-2360">
                <button onClick={handleLater} className="text-sm text-gray-600 hover:text-gray-500 transition-colors" data-id="element-2361">
                  I'll come back to this later
                </button>
              </div>

              {/* EMAIL CONFIRMATION */}
              <p className="text-xs text-gray-600" data-id="element-2362">
                A copy has also been sent to your email.
              </p>
            </div>
          </div>
        </main>
      </div>
    </>;
}